<div class="container h-100">
  <div class="row h-100">
    <div class="col-sm-12 h-100 d-table">
      <div class="card card-block d-table-cell align-middle text-center">
        <h1>{{ 'application_errors.page_not_found' | transloco }}</h1>
      </div>
    </div>
  </div>
</div>
